export class ImageUtil {
  public static resizeImage(
    image: HTMLImageElement,
    width: number,
    mimeType: string
  ) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (ctx) {
      const height = width * (image.height / image.width);
      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(image, 0, 0, width, height);
      return canvas.toDataURL(mimeType, 1);
    }
    return undefined;
  }

  public static resizeImageToBlob(
    img: HTMLImageElement,
    maxWidth: number,
    mimeType: string
  ): Promise<Blob | undefined> {
    return new Promise(resolve => {
      const scale = maxWidth / img.width;
      const canvas = document.createElement('canvas');
      canvas.width = maxWidth;
      canvas.height = img.height * scale;

      const ctx = canvas.getContext('2d');
      if (!ctx) return resolve(undefined);

      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(blob => resolve(blob || undefined), mimeType);
    });
  }
}
